// /store/modules/Marketing.js

import apiClient from "../../plugins/axios";

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        loadedModels: [],
    }),
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setModels(state, models) {
            state.loadedModels = models;
        },
    },
    actions: {
        async savePriceModel({ commit }, payload) {
            commit("setLoading", true);
            try {
                const response = await apiClient.post("/statistics/calcSlotPricing", payload);
                console.log(response.data);
            } catch (error) {
                console.error("Failed to save price model:", error);
            } finally {
                commit("setLoading", false);
            }
        },
        async getPriceModels({ commit }) {
            commit("setLoading", true);
            try {
                const response = await apiClient.get("/statistics/calcSlotPricing");
                commit("setModels", response.data);
            } catch (error) {
                console.error("Failed to get price models:", error);
            } finally {
                commit("setLoading", false);
            }
        }
    },
};